export const COLOR_PALETTE = {
  PRIMARY: '#1d816d',
  SECONDARY: '#ee6064',
}

export const PHASE_OPTIONS = [
  { key: 'before', title: 'Trước', value: 'before' },
  { key: 'after', title: 'Sau', value: 'after' },
]
